import React from 'react';
import { isEqual } from 'lodash';
import { FormInput } from '~/components/FormComponents/FormInput';
import { FormDateInput } from '~/components/FormComponents/FormDateInput';
import FormGridItem from '~/components/FormComponents/FormGridItem';

interface PersonalInfoBlockProps {
  isDisabledForm?: boolean;
  section?: string;
  isBirthDateHidden?: boolean;
}

const PersonalInfoBlock = ({
  isDisabledForm,
  section,
  isBirthDateHidden,
}: PersonalInfoBlockProps) => {
  const prefix = section ? section + '.' : '';
  return (
    <>
      <FormGridItem>
        <FormInput
          name={`${prefix}lastName`}
          disabled={isDisabledForm}
          placeholder="Введіть прізвище"
          label="Прізвище"
          fullWidth
        />
      </FormGridItem>
      <FormGridItem>
        <FormInput
          disabled={isDisabledForm}
          label="Ім'я"
          placeholder="Введіть ім'я"
          name={`${prefix}firstName`}
          fullWidth
        />
      </FormGridItem>
      <FormGridItem>
        <FormInput
          disabled={isDisabledForm}
          label="По батькові (за наявності)"
          placeholder="Введіть по батькові"
          name={`${prefix}middleName`}
          fullWidth
        />
      </FormGridItem>
      {!isBirthDateHidden && (
        <FormGridItem>
          <FormDateInput
            disabled={isDisabledForm}
            label="Дата народження"
            name={`${prefix}birthDate`}
            isCurrentMaxDate
            placeholder="Введіть або оберіть дату народження"
          />
        </FormGridItem>
      )}
    </>
  );
};

const areEqual = (prevProps: PersonalInfoBlockProps, nextProps: PersonalInfoBlockProps) => {
  return isEqual(prevProps, nextProps);
};

export default React.memo(PersonalInfoBlock, areEqual);
